// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"04bc5ef7","714":"53814923","717":"3e43c937","942":"90fdf122"}[chunkId] + ".chunk.js";
};